import React, { useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { CircularProgress } from "@material-ui/core";
import { toTimestamp, toTimestampDate } from "../../../../utils/appUtils";
import { getTokenTransactionAsync } from "../../redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import moment from "moment";

const TokenTransactionDetail = () => {
  const { id } = useParams();
  const history = useHistory();

  // const [isLoading, setIsLoading] = useState(true);

  const { isLoading, selectedVirtualToken } = useSelector(
    (state) => state.tokenTransaction,
    shallowEqual
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTokenTransactionAsync(id));
  }, [id]);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!selectedVirtualToken) {
    return (
      <div className="form-group m-0 d-flex align-items-center text-white">
        <span className="pl-2">Transaction detail not found</span>
      </div>
    );
  }

  return (
    <Card>
      <CardHeader
        title={
          <>
            <div className="form-group m-0 d-flex align-items-center ">
              <Link
                className="btn btn-link px-0 text-white"
                to="/token-transaction"
              >
                <SVG
                  className="h-50 align-self-center text-white right-caret-btn"
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Arrow-left.svg"
                  )}
                />
                Back
              </Link>
              <span className="pl-2">Token Transaction Details</span>
            </div>
          </>
        }
      >
        <CardHeaderToolbar>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <form
              autoComplete="off"
              className="subheader_filter"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="form-row"></div>
            </form>
          </div>
        </CardHeaderToolbar>
      </CardHeader>
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white">
            <h4 className="mb-0">Token Transaction Details</h4>
          </div>
          <div className="card-body text-light">
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                User Name:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.userName || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Bet ID:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                <a
                  style={{ color: "#fff" }}
                  href={`/bet-management/bet-result-details/${selectedVirtualToken.bet_id}`}
                  target="_blank"
                >
                  {selectedVirtualToken?.bet_id}
                </a>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Transaction Type:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>

                {
                !selectedVirtualToken.isCancelMatch && !selectedVirtualToken.isVoidMatch
                ? selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE" &&
                selectedVirtualToken.description === "DEPOSITED_BY_ADMIN"
                ? "Deposited By Admin"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE" &&
                selectedVirtualToken.description?.startsWith("REFERRAL_BONUS")
                ? "Referral Bonus"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE" &&
                selectedVirtualToken.description?.startsWith("REFERRAL_SIGNUP_BONUS")
                ? "Signup Bonus"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE" &&
                selectedVirtualToken.description?.startsWith("PROMO_CODE_APPLIED")
                ? "Deposit By Promo Code"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE"
                ? "Deposit"
                : selectedVirtualToken.transaction_type === "DEBIT" &&
                selectedVirtualToken.balance_type === "WITHDRAWABLE" &&
                selectedVirtualToken.withdrawal_approved === false
                ? "Withdrawal Requested"
                : selectedVirtualToken.transaction_type === "DEBIT" &&
                selectedVirtualToken.balance_type === "WITHDRAWABLE" &&
                selectedVirtualToken.withdrawal_approved === true
                ? "Withdrawal Success"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "WITHDRAWABLE" &&
                selectedVirtualToken.is_decline === true
                ? "Withdrawal Declined"
                : selectedVirtualToken.transaction_type === "CREDIT" &&
                selectedVirtualToken.balance_type === "WITHDRAWABLE"
                ? "Won Bet"
                : selectedVirtualToken.transaction_type === "DEBIT" &&
                selectedVirtualToken.balance_type === "NON_WITHDRAWABLE"
                ? "Created/Joined Bet"
                : selectedVirtualToken.transaction_type === "DEBIT" &&
                selectedVirtualToken.balance_type === "WITHDRAWABLE"
                ? "Withdrawal"
                : ""
                : selectedVirtualToken.isCancelMatch
                ? "Cancelled Bet"
                : selectedVirtualToken.isVoidMatch
                ? "Voided Bet"
                : ""
                }

          

              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">Token:</div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.amount || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Transaction ID:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.transactionId || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Non-Withdrawable Tokens:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.non_withdrawable_token || 0}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Withdrawable Tokens:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.withdrawable_token || 0}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Status:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken ? (
                  <button
                    value={selectedVirtualToken.status}
                    className={`pmnt_btn ${
                      selectedVirtualToken.status === "SUCCESS"
                        ? "label label-lg label-light-success label-inline"
                        : selectedVirtualToken.status === "PENDING"
                        ? "label label-lg label-light-warning label-inline"
                        : "label label-lg label-light-danger label-inline"
                    }`}
                  >
                    {selectedVirtualToken.status === "SUCCESS"
                      ? "SUCCESS"
                      : selectedVirtualToken.status === "PENDING"
                      ? "PENDING"
                      : "FAILED"}
                  </button>
                ) : (
                  "-"
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Approved By Admin:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken.balance_type === "WITHDRAWABLE" &&
                selectedVirtualToken.transaction_type === "DEBIT" ? (
                  <button
                    value={
                      selectedVirtualToken &&
                      selectedVirtualToken.withdrawal_approved
                    }
                    className={`pmnt_btn ${
                      selectedVirtualToken
                        ? selectedVirtualToken.withdrawal_approved === false &&
                          selectedVirtualToken.is_decline === false
                          ? "label label-lg label-light-warning label-inline"
                          : selectedVirtualToken.withdrawal_approved === true
                          ? "label label-lg label-light-success label-inline"
                          : selectedVirtualToken.is_decline === true
                          ? "label label-lg label-light-danger label-inline" // Added red color for decline
                          : ""
                        : ""
                    }`}
                    // onClick={() => {
                    //   if (!selectedVirtualToken.withdrawal_approved) {
                    //     onApprovedClick(selectedVirtualToken);
                    //   }
                    // }}
                  >
                    {selectedVirtualToken &&
                    selectedVirtualToken.withdrawal_approved === false &&
                    selectedVirtualToken.is_decline === false
                      ? "Pending"
                      : selectedVirtualToken.withdrawal_approved === true
                      ? "Approved"
                      : selectedVirtualToken.is_decline === true
                      ? "Declined"
                      : "-"}
                  </button>
                ) : (
                  "-"
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Admin Approved Payment:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.admin_approved ? (
                  <div>
                    <span className="label label-lg label-light-success label-inline mr-2">
                      Approved
                    </span>
                    <span>
                      {moment(selectedVirtualToken.admin_approved).format(
                        "dddd, MMMM Do YYYY, h:mm:ss a"
                      )}
                    </span>
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Decline Reason:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.decline_reason || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Description:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.description || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Created At:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken?.createdAt
                  ? moment(selectedVirtualToken.createdAt).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )
                  : "-"}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Transaction Logs:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedVirtualToken.transactionLogs ? (
                  <pre style={{ color: "white" }}>
                    {JSON.stringify(
                      selectedVirtualToken.transactionLogs,
                      null,
                      2
                    )}
                  </pre>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TokenTransactionDetail;
